var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProductCheckmark = function SvgProductCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 360 360"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#EAAA08",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m337.55 114.33-53.41 53.4M15.5 211.24l109.73 109.74a4.01 4.01 0 0 0 5.66 0l115.06-115.06"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F04438",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m8.5 184.24 116.74 116.74a4.01 4.01 0 0 0 5.66 0L345.05 86.83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EE46BC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m113.09 268.84 12.14 12.14a4.01 4.01 0 0 0 5.66 0L350.05 61.83M74.9 230.65 6 161.74"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#875BF7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m354.55 37.33-41.91 41.9M6 141.74l119.23 119.24a4.01 4.01 0 0 0 5.66 0l143.56-143.56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0BA5EC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m22.5 138.24 102.74 102.74a4.01 4.01 0 0 0 5.66 0L337.87 34"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#12B76A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m314.05 36.83-113.41 113.4M58.9 153.65l-18.4-18.41M97.09 191.84l28.14 28.14a4.01 4.01 0 0 0 5.66 0l31.56-31.56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#141414",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m59.5 134.24 65.74 65.74a4.01 4.01 0 0 0 5.66 0L286.05 44.83"
  })));
};
export default SvgProductCheckmark;